import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  RowSettingsResolveModalComponent, type RowSettingsResolveModalComponentProps,
} from './replaceDataRowSettingsResolveModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    RowSettingsResolve: Omit<RowSettingsResolveModalComponentProps, 'isOpen' | 'onClose'>;
  }
}

modalRenderer.register('RowSettingsResolve', (props) => <RowSettingsResolveModalComponent {...props} />);
